import { useEffect } from "react";

export function useTitle(title: string) {
  useEffect(() => {
    document.title = `SÄLJA - ${title}`;
  }, [title]);
}
